import { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@tonic/shared/components/ui';
import { Button } from '@tonic/shared/components/ui';
import { ArrowLeft } from 'lucide-react';
import { BasicInfoTab } from './tabs/BasicInfoTab';
import { ImagesTab } from './tabs/ImagesTab';
import { PricingTab } from './tabs/PricingTab';
import { ReCommerceTab } from './tabs/ReCommerceTab';
import { HistoryTab } from './tabs/HistoryTab';
import { useProduct } from '../../hooks/useProduct';

export function ProductDetailPage() {
  const { id } = useParams();
  const { data: product, isLoading } = useProduct(id);
  const [activeTab, setActiveTab] = useState('basic');

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
      </div>
    );
  }

  if (!product) {
    return (
      <div className="text-center py-12">
        <h2 className="text-2xl font-semibold">Product not found</h2>
        <p className="text-muted-foreground mt-2">The product you're looking for doesn't exist.</p>
        <Link to="/products">
          <Button variant="link" className="mt-4">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back to Products
          </Button>
        </Link>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <Link to="/products">
          <Button variant="ghost" size="sm">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back
          </Button>
        </Link>
        <div>
          <h1 className="text-3xl font-bold">Product: {product.name}</h1>
          <p className="text-muted-foreground">SKU: {product.sku}</p>
        </div>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-4">
        <TabsList>
          <TabsTrigger value="basic">Basic Info</TabsTrigger>
          <TabsTrigger value="images">Images & Media</TabsTrigger>
          <TabsTrigger value="pricing">Pricing & Variants</TabsTrigger>
          <TabsTrigger value="reCommerce">Re-Commerce Attributes</TabsTrigger>
          <TabsTrigger value="history">History</TabsTrigger>
        </TabsList>

        <TabsContent value="basic" className="space-y-4">
          <BasicInfoTab product={product} />
        </TabsContent>

        <TabsContent value="images" className="space-y-4">
          <ImagesTab product={product} />
        </TabsContent>

        <TabsContent value="pricing" className="space-y-4">
          <PricingTab product={product} />
        </TabsContent>

        <TabsContent value="reCommerce" className="space-y-4">
          <ReCommerceTab product={product} />
        </TabsContent>

        <TabsContent value="history" className="space-y-4">
          <HistoryTab product={product} />
        </TabsContent>
      </Tabs>
    </div>
  );
} 